"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayTripItineraryItemAdmission = void 0;
var DayTripItineraryItemAdmission;
(function (DayTripItineraryItemAdmission) {
    DayTripItineraryItemAdmission["included"] = "included";
    DayTripItineraryItemAdmission["notIncluded"] = "notIncluded";
    DayTripItineraryItemAdmission["hidden"] = "hidden";
})(DayTripItineraryItemAdmission || (exports.DayTripItineraryItemAdmission = DayTripItineraryItemAdmission = {}));
//# sourceMappingURL=day-trip-itinerary-item-admission.enum.js.map